import { render, staticRenderFns } from "./InstagramCallback.vue?vue&type=template&id=25580558&scoped=true"
import script from "./InstagramCallback.vue?vue&type=script&lang=js"
export * from "./InstagramCallback.vue?vue&type=script&lang=js"
import style0 from "./InstagramCallback.vue?vue&type=style&index=0&id=25580558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25580558",
  null
  
)

export default component.exports